<button (click)="toggleFullscreen()" class="fullscreen-mode">
	{{ fullscreenService.isFullscreen() ? 'Exit Fullscreen' : 'Open Fullscreen' }}
</button>
<router-outlet></router-outlet>
